<template>
  <div class="downloadHistory">
    <notifications :messages="notifications" v-if="notifications && notifications.length > 0"/>
    <spinner v-if="loading"></spinner>
    <table class="table table-striped table-hover">
      <thead class="fixedHeader">
      <tr>
        <th>
          Requested By
        </th>
        <th>
          Date Created
        </th>
        <th>
          Status
        </th>
        <th>
          Progress
        </th>
        <th>
          Actions
        </th>
      </tr>
      </thead>
      <tbody class="scrollContent" v-for="data in tableData" :key="data.id">
      <tr>
          <td>
           <span>
          <a v-bind:href="'mailto:' + data.username + '?subject=Otomo Download query'" target="_blank">{{ data.name }}</a>
           </span>
          </td>
          <td>
          {{data.date_created.value}}
          </td>
          <td>
           <span :class="statusCss(data.status)">
            {{ data.status.replace('_', ' ') }}
          </span>
          </td>
          <td>
           <progress-bar :value="data.progress" :status="data.status.replace('_', ' ').toLowerCase()" />
          </td>
          <td style="display: flex; flex-direction: row">
          <button v-if="data.progress === 100 && data.status === 'success' && data.url" @click="downloadFile(data.url)" class="btn btn-xs btn-primary">
            <i class="fa fa-download"></i> Download
          </button>
            <div v-else-if="data.progress === 100 && data.status === 'success' && data.url === null && data.creative.type === 'after-effects' && data.type !== null">
              Moved Files To DAM
            </div>
            <div v-else-if="data.status !== 'created'">&nbsp;&nbsp;-</div>
            <div v-if="data.status === 'created' && data.creative.type === 'after-effects'">
              <button @click="processFile(data.hash_id, 'direct')" class="btn btn-xs btn-primary" :disabled="data.type === 'move'">
                <i class="fa fa-download"></i> Start Download
              </button>
              <button v-if="profileUser.bucket" @click="processFile(data.hash_id, 'move')" class="btn btn-xs btn-primary">
                <i class="fa fa-arrows"></i> Move files to DAM
              </button>
              <p v-else-if="data.status !== 'created'">&nbsp;&nbsp;-</p>
            </div>
            <button class="btn btn-xs btn-primary ml-4" @click="toggleAccordion(data.hash_id)">
              <i v-if="isAccordionOpen(data.hash_id)" class="fa fa-times"></i>
              <i v-else class="fa fa-info"></i>
            </button>
          </td>
      </tr>
      <tr v-if="isAccordionOpen(data.hash_id)">
        <td colspan="5">
          <accordion>
            <ul>
              <li v-for="unit in data.units" :key="unit">
                {{ unit }}
              </li>
            </ul>
          </accordion>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import ProgressBar from '@/components/ProgressBar/progress-bar'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import Spinner from '@/components/SpinnerIcon/spinner.vue'
import Notifications from '@/components/Notifications/notifications'
import {downloadMixin} from '@/mixins/downloadMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {MEDIA_URL} from '@/config'
import {profileMixin} from '@/mixins/profileMixin'
import {CreativeUnits} from '../../pages/creatives/creative-units'

export default {
  name: 'DownloadTable',
  mixins: [downloadMixin, modalMixin, notificationMixin, profileMixin],
  components: {
    SlotTable,
    ButtonCta,
    Field,
    ProgressBar,
    SwitchButton,
    Checkbox,
    Heading,
    Notifications,
    Spinner,
    CreativeUnits
  },
  props: {
    tableData: Array,
    creativeUnitName: {
      type: String,
      required: true
    }
  },
  data: () => ({
    table: {
      columns: {
        requestedBy: 'Requested By',
        dateCreated: 'Date Created',
        status: 'Status',
        progress: 'Progress',
        actions: 'Actions'
      },
      statusKeys: {
        success: 'success',
        error: 'danger',
        in_progress: 'info',
        created: 'warning'
      }
    },
    openAccordions: []
  }),
  methods: {
    downloadFile (file) {
      window.open(`${MEDIA_URL}${file}`, '_blank').focus()
    },
    processFile (hashid, type) {
      this.startLoading()
      const formData = new FormData()
      formData.append('type', type)
      formData.append('hashid', hashid)
      this.processDownload(formData).then((response) => {
        const notification = this.addNotification('success', response.reason)
        setTimeout(() => this.closeLastNotification(notification.id), 5000)
        this.getCreativeDownloads(this.$route.params.id).then(() => {
          this.finishLoading()
        })
      }, error => {
        this.addNotification('danger', error)
        this.finishLoading()
      })
    },
    statusCss (status) {
      let labelType = 'default'
      if (status !== 'new') {
        labelType = this.table.statusKeys[status]
      }
      return `label label-${labelType} text-center text-capitalize`
    },
    toggleAccordion (hashId) {
      if (this.isAccordionOpen(hashId)) {
        const index = this.openAccordions.indexOf(hashId)
        if (index !== -1) {
          this.openAccordions.splice(index, 1)
        }
      } else {
        this.openAccordions.push(hashId)
      }
    },
    isAccordionOpen (hashId) {
      return this.openAccordions.includes(hashId)
    }
  }
}
</script>

<style lang="scss">
.asset__img, .asset__video {
  background-color: #ccc;
  background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
  background-size: 10px 10px;
  background-position: 0 0, 5px 5px;
  padding: 0px;
  max-width: 200px;
  max-height: 200px;
  img, video {
    object-fit: scale-down;
    border:2px solid #2c3247;
  }
  & #imageCover {
    z-index:50;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(123,123,123,0);
  }
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.asset__video {
  background-color: black;
  max-width: 320px;
  max-height: 320px;
}
.top-buffer {
  margin-top:10px;
}

.progress-percentage {
  display: flex;
  align-content: center;
}

.loader-hidden {
  display: inline-block;
  width: 15px;
  height: 15px;
}

.loader {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 2px;
  background-color: #333;

  border-radius: 100%;
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
      opacity: 0;
    }
}
.custom_design{
  position: absolute;
  left: 18%;
  margin-top: -5px;
  display: flex;
  flex-direction: column;
}
.ml-4 {
 margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadTable/download-table.vue